module.exports = __webpack_public_path__ + "img/solution-scene.062f9538.png";